import React from "react";

const OUTER_PADDING = 16;

const styles = {
    shell: {
        position: "relative",
        width: "100%",
        height: `calc(100dvh - var(--playground-page-offset, 0px) - ${OUTER_PADDING * 2}px)`,
        minWidth: 0,
        minHeight: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: "24px",
        background: [
            "radial-gradient(circle at 14% 12%, rgba(59, 130, 246, 0.14), transparent 24%)",
            "radial-gradient(circle at 82% 18%, rgba(168, 85, 247, 0.08), transparent 22%)",
            "radial-gradient(circle at 50% 100%, rgba(255, 255, 255, 0.04), transparent 28%)",
            "linear-gradient(180deg, rgba(4, 8, 18, 0.98), rgba(2, 6, 14, 1))",
        ].join(", "),
        boxShadow:
            "0 28px 80px rgba(0, 0, 0, 0.42), inset 0 1px 0 rgba(255, 255, 255, 0.05)",
        isolation: "isolate",
    },
    noiseLayer: {
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        opacity: 0.4,
        background: [
            "radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.04), transparent 16%)",
            "radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.025), transparent 18%)",
            "radial-gradient(circle at 35% 75%, rgba(255, 255, 255, 0.03), transparent 22%)",
        ].join(", "),
    },
    canvasRegion: {
        position: "absolute",
        inset: 0,
        minWidth: 0,
        minHeight: 0,
        overflow: "hidden",
    },
    overlayTopLeft: {
        position: "absolute",
        top: "18px",
        left: "18px",
        zIndex: 5,
        pointerEvents: "auto",
        maxWidth: "min(34vw, 520px)",
    },
    overlayTopRight: {
        position: "absolute",
        top: "18px",
        right: "18px",
        zIndex: 5,
        pointerEvents: "auto",
        maxWidth: "min(30vw, 420px)",
    },
    overlayBottomLeft: {
        position: "absolute",
        bottom: "18px",
        left: "18px",
        zIndex: 5,
        pointerEvents: "auto",
        maxWidth: "min(30vw, 360px)",
    },
    overlayBottomRight: {
        position: "absolute",
        bottom: "18px",
        right: "18px",
        zIndex: 5,
        pointerEvents: "auto",
        maxWidth: "min(36vw, 440px)",
    },
};

const overlayStyleMap = {
    "top-left": styles.overlayTopLeft,
    "top-right": styles.overlayTopRight,
    "bottom-left": styles.overlayBottomLeft,
    "bottom-right": styles.overlayBottomRight,
};

function renderOverlaySlot(position, node) {
    if (!node) {
        return null;
    }

    return (
        <div key={position} style={overlayStyleMap[position]}>
            {node}
        </div>
    );
}

export default function DominosStageShell({ overlaySlots, children }) {
    return (
        <div style={styles.shell}>
            <div style={styles.noiseLayer} />

            {overlaySlots
                ? Object.entries(overlaySlots).map(([position, node]) =>
                    renderOverlaySlot(position, node)
                )
                : null}

            <div style={styles.canvasRegion}>{children}</div>
        </div>
    );
}